import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SubmissionError } from 'redux-form'

import { setActiveTab } from 'ducks/editor/tabs'

import history from '../../../../history'
import Page from '../../../Shared/Page'
import Modal from '../../../Shared/Modal'
import { getApp } from '../../../../ducks/apps'

import InviteForm from './InviteForm'
import {
  createInvite,
  getOrganizations,
  fetchOrganizations,
} from '../../../../ducks/organizations'

import { INVITE_LIMIT_MESSAGE } from '../../../../constants'
import { searchUsers } from '../../../../ducks/searchUsers'
import { addAppUser, requestAppUsers } from '../../../../ducks/appUsers'

import '../Settings.css'

class InviteModal extends Component {
  getOrganization = () => {
    const { app, organizations } = this.props

    for (let i = 0; i < organizations.length; i += 1) {
      if (app.Organization.id === organizations[i].id) {
        return organizations[i]
      }
    }
  }

  handleSubmit = async ({ email }) => {
    const { createInvite, app, requestAppUsers, searchUsers } = this.props
    const organization = this.getOrganization()
    const members = organization.Users
    email = email.toLowerCase()

    const sameEmail = members.filter(u => u.email === email)

    if (sameEmail.length > 0) {
      throw new SubmissionError({
        email: `${email} is already part of your team!`,
      })
    }

    try {
      await createInvite({
        email,
        organizationId: app.Organization.id,
        appId: app.id,
      })

      requestAppUsers(app.id)
      this.fetchData()
    } catch (err) {
      const status = err.response && err.response.status
      const data = err.response && err.response.data
      let message = (data && data.error) || 'An unknown error occurred'

      if (status === 429) {
        message = INVITE_LIMIT_MESSAGE
      }

      throw new SubmissionError({
        email: message,
      })
    }

    let users = []

    try {
      users = (await searchUsers(email)).value
      addAppUser(app.id, users[0].id)
      requestAppUsers(app.id)
    } catch (err) {
      console.log('ERROR:', err)
    }

    this.closeModal()
  }

  closeModal = () => {
    const { match, app, requestAppUsers, setActiveTab } = this.props
    requestAppUsers(app.id)
    setActiveTab('settings')
    history.push(`/apps/${match.params.appId}/app-settings?active=access`)
  }

  fetchData = () => {
    const { fetchOrganizations } = this.props

    fetchOrganizations()
  }

  componentDidMount() {
    this.fetchData()
  }

  render() {
    const { app } = this.props

    const title = app?.name
      ? `Invite New Team Member - ${app.name}`
      : 'Invite New Team Member'

    return (
      <Modal onClose={this.closeModal}>
        <Page className="accounts-page" title={title}>
          <InviteForm onSubmit={this.handleSubmit} onClose={this.closeModal} />
        </Page>
      </Modal>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  app: getApp(state, match.params.appId),
  organizations: getOrganizations(state),
})

export default connect(mapStateToProps, {
  createInvite,
  fetchOrganizations,
  searchUsers,
  addAppUser,
  requestAppUsers,
  setActiveTab,
})(InviteModal)
